export const projectRecordsKeys = {
  all: ["project-records"] as const,
  list: (projectId: string) => [...projectRecordsKeys.all, projectId] as const,
};
